import { BaseError } from '@nsftx/seven-client-retail-utils'
import type { DmPrintErrorType } from '#src/types/DmPrintErrorTypes'
import type { PrinterStatus } from '#src/interfaces/PrinterStatus'

export default class DmPrintError extends BaseError<DmPrintErrorType> {
  constructor(
    public message: string,
    public code: DmPrintErrorType,
    public options?: {
      cause?: unknown
      context?: {
        printerStatus: PrinterStatus
      }
    }
  ) {
    super(message, code, options)
    Object.setPrototypeOf(this, DmPrintError.prototype)
    this.name = this.constructor.name
  }
}
